import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { CultureStateAggData } from 'src/app/moov-common/services/data/data-data';

@Component({
  selector: 'app-culture-breakdown',
  templateUrl: './culture-breakdown.component.html',
  styleUrl: './culture-breakdown.component.scss',
})
export class CultureBreakdownComponent extends BaseComponent {
  @Input() selectedCulture: CultureStateAggData | null | undefined = null;
  @Output() closeClicked = new EventEmitter<void>();

  constructor() {
    super();
  }

  onCloseClick(): void {
    this.closeClicked.emit();
  }
}
